"use strict";

const FORM_SELECTOR = "[data-contact-form]";
const NOTIFY_SELECTOR = "[data-contact-form-notify]";
const SUBMIT_SELECTOR = "[data-contact-form-submit]";
const COMPANY_FIELD_SELECTOR = "[data-contact-company-field]";
const COMPANY_WRAP_SELECTOR = "[data-contact-company-wrap]";
const CUSTOMER_TYPE_SELECTOR = "[data-contact-customer-type]";
const AJAX_ACTION = "contact_form_action";

function getRecaptchaResponse(form) {
    if (!window.WPURLS?.recaptcha?.enabled) {
        return "";
    }

    if (typeof window.grecaptcha === "undefined") {
        return "";
    }

    const widget = form.querySelector(".g-recaptcha");

    if (!widget) {
        return "";
    }

    return window.grecaptcha.getResponse();
}

function resetRecaptcha(form) {
    if (!window.WPURLS?.recaptcha?.enabled || typeof window.grecaptcha === "undefined") {
        return;
    }

    const widget = form.querySelector(".g-recaptcha");

    if (!widget) {
        return;
    }

    window.grecaptcha.reset();
}

function setNotify(notify, type, message) {
    if (!notify) {
        return;
    }

    notify.className = "form-notify";

    if (type) {
        notify.classList.add(type);
    }

    notify.textContent = message || "";
}

function updateCompanyFieldVisibility(form) {
    const companyField = form.querySelector(COMPANY_FIELD_SELECTOR);
    const companyWrap = form.querySelector(COMPANY_WRAP_SELECTOR);
    const selectedType = form.querySelector(`${CUSTOMER_TYPE_SELECTOR}:checked`);

    if (!companyField) {
        return;
    }

    const isCompany = selectedType?.value === "company";
    companyField.required = isCompany;

    if (companyWrap) {
        companyWrap.hidden = !isCompany;
    }

    if (!isCompany) {
        companyField.value = "";
        companyField.classList.remove("is-invalid");
    }
}

function initContactForm(form) {
    const notify = form.querySelector(NOTIFY_SELECTOR);
    const submitButton = form.querySelector(SUBMIT_SELECTOR);

    form.querySelectorAll(CUSTOMER_TYPE_SELECTOR).forEach((input) => {
        input.addEventListener("change", () => updateCompanyFieldVisibility(form));
    });

    updateCompanyFieldVisibility(form);

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!window.WPURLS?.ajaxUrl) {
            return;
        }

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const recaptchaResponse = getRecaptchaResponse(form);

        if (window.WPURLS.recaptcha?.enabled && !recaptchaResponse) {
            setNotify(notify, "error", window.WPURLS.recaptcha.error);
            return;
        }

        const defaultMessage = window.WPURLS.mail_message?.error || "";
        const sendingMessage = window.WPURLS.mail_message?.sending || "";
        const successMessage = window.WPURLS.mail_message?.success || "";

        if (submitButton) {
            submitButton.disabled = true;
        }

        setNotify(notify, "info", sendingMessage);

        const data = new FormData(form);
        data.append("action", AJAX_ACTION);

        if (recaptchaResponse) {
            data.append("g-recaptcha-response", recaptchaResponse);
        }

        try {
            const response = await fetch(window.WPURLS.ajaxUrl, {
                method: "POST",
                credentials: "same-origin",
                body: data,
            });

            const payload = await response.json();
            const isSuccess = Boolean(payload?.success);

            setNotify(
                notify,
                isSuccess ? "success" : "error",
                payload?.message || defaultMessage
            );

            if (isSuccess) {
                form.reset();
                updateCompanyFieldVisibility(form);
                resetRecaptcha(form);
            }
        } catch (error) {
            setNotify(notify, "error", defaultMessage);
        } finally {
            if (submitButton) {
                submitButton.disabled = false;
            }
        }
    });
}

function initContactForms() {
    document.querySelectorAll(FORM_SELECTOR).forEach(initContactForm);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initContactForms, { once: true });
} else {
    initContactForms();
}
